//元素预览样式
import './style.css';


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4public/wea-element-preview/content/css/index.js